<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline" v-if="type === 'categories'">Catégories</span>
        <span class="headline" v-if="type === 'costCenters'"
          >Centre de coûts</span
        >
        <span class="headline" v-if="type === 'places'">Emplacements</span>
        <span class="headline" v-if="type === 'entities'">Entités</span>
        <span class="headline" v-if="type === 'inventoryDeletionCauses'"
          >Raisons de sortie</span
        >
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12">
              <v-text-field
                label="Nom*"
                required
                outlined
                :rules="[() => !!payload.name || 'Ce champ est requis.']"
                v-model="payload.name"
                :disabled="!admin"
              ></v-text-field>
              <div v-if="type === 'places'">
                <v-text-field
                  label="Salle*"
                  outlined
                  required
                  v-model="payload.room"
                  :rules="[() => !!payload.room || 'Ce champ est requis.']"
                  :disabled="!admin"
                ></v-text-field>
                <v-text-field
                  label="Armoire*"
                  outlined
                  required
                  v-model="payload.cabinet"
                  :rules="[() => !!payload.cabinet || 'Ce champ est requis.']"
                  :disabled="!admin"
                ></v-text-field>
                <v-select
                  v-model="payload.entity"
                  required
                  :rules="[() => !!payload.entity || 'Ce champ est requis.']"
                  :items="entities"
                  item-text="name"
                  item-value="_id"
                  outlined
                  label="Entité*"
                  :disabled="!admin"
                />
              </div>
              <div v-if="type === 'entities'">
                <v-text-field
                  label="Département*"
                  outlined
                  v-model="payload.department"
                  :rules="[
                    () => !!payload.department || 'Ce champ est requis.',
                  ]"
                  required
                  :disabled="!admin"
                ></v-text-field>
                <v-text-field
                  label="Type*"
                  outlined
                  v-model="payload.type"
                  :rules="[() => !!payload.type || 'Ce champ est requis.']"
                  required
                  :disabled="!admin"
                ></v-text-field>
                <v-text-field
                  label="Numéro*"
                  outlined
                  type="number"
                  v-model="payload.number"
                  :rules="[() => !!payload.number || 'Ce champ est requis.']"
                  required
                  :disabled="!admin"
                ></v-text-field>
                <v-select
                  v-model="payload.costCenter"
                  :rules="[
                    () => !!payload.costCenter || 'Ce champ est requis.',
                  ]"
                  required
                  :items="costCenters"
                  item-text="name"
                  item-value="_id"
                  outlined
                  label="Centre de coûts*"
                  :disabled="!admin"
                />
              </div>
            </v-col>
          </v-row>
        </v-container>
        <small>*indique un champ requis</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">Fermer</v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="submitForm"
          :disabled="!validForm"
          v-if="admin"
          >Sauver</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import dashify from "dashify";

export default {
  data: () => ({
    valid: true
  }),
  props: [
    "dialog",
    "type",
    "displaySnackbar",
    "updateParam",
    "closeDialog",
    "payload",
    "entities",
    "costCenters",
    "admin"
  ],
  methods: {
    submitForm: async function() {
      if (this.payload._id) {
        try {
          const { data } = await axios({
            method: "patch",
            url: `${process.env.VUE_APP_API_URI}/${dashify(this.type)}/${
              this.payload._id
            }`,
            data: {
              ...this.payload
            }
          });
          this.updateParam(this.type, data);
          this.displaySnackbar({
            visible: true,
            text: "Paramètre mis à jour",
            color: "success"
          });
        } catch (error) {
          this.closeDialog();
          this.displaySnackbar({
            visible: true,
            text: "Erreur de sauvegarde",
            color: "red"
          });
        }
      } else {
        try {
          const { data } = await axios({
            method: "post",
            url: `${process.env.VUE_APP_API_URI}/${dashify(this.type)}`,
            data: {
              ...this.payload
            }
          });
          data.count = 0;
          this.updateParam(this.type, data);
          this.displaySnackbar({
            visible: true,
            text: "Paramètre ajouté",
            color: "success"
          });
        } catch (error) {
          this.displaySnackbar({
            visible: true,
            text: "Erreur de sauvegarde",
            color: "red"
          });
        }
      }
    }
  },
  computed: {
    validForm: function() {
      const {
        name,
        room,
        cabinet,
        entity,
        department,
        type,
        number,
        costCenter
      } = this.payload;
      if (this.type === "places") {
        return !!name && !!room && !!cabinet && !!entity;
      }
      if (this.type === "entities") {
        return !!name && !!department && !!type && !!number && !!costCenter;
      }
      return !!name;
    }
  }
};
</script>